"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toResolutionDiffView = toResolutionDiffView;
function canonicalizeKeys(value) {
    if (Array.isArray(value)) {
        return value.map((item) => canonicalizeKeys(item));
    }
    if (value !== null && typeof value === 'object') {
        const source = value;
        const result = {};
        for (const key of Object.keys(source).sort()) {
            const child = source[key];
            if (child === undefined) {
                continue;
            }
            result[key] = canonicalizeKeys(child);
        }
        return result;
    }
    return value;
}
function orderBy(items, key) {
    return [...items].sort((a, b) => key(a).localeCompare(key(b)));
}
function stableJson(value) {
    return JSON.stringify(canonicalizeKeys(value));
}
const VOLATILE_KEYS = new Set(['id', 'metadata', 'isReviewed']);
function stripVolatile(record) {
    const result = {};
    for (const [key, value] of Object.entries(record)) {
        if (VOLATILE_KEYS.has(key)) {
            continue;
        }
        result[key] = value;
    }
    return result;
}
function toResolutionDiffView(resolution) {
    const signalNameById = new Map();
    for (const signal of resolution.signals) {
        signalNameById.set(String(signal.id), signal.name);
    }
    const signalName = (ref) => {
        if (ref === null || ref === undefined) {
            return null;
        }
        return signalNameById.get(String(ref)) ?? String(ref);
    };
    const view = {
        sigmaModelId: resolution.sigmaModelId,
        signals: orderBy(resolution.signals.map(stripVolatile), (signal) => String(signal['name'] ?? '')),
        pins: orderBy(resolution.pins.map((pin) => ({ name: pin.name, signal: signalName(pin.signalRef) })), (pin) => pin.name),
        sigmaModelParameters: resolution.sigmaModelParameters,
        spiceModels: orderBy(resolution.spiceModels.map(stripVolatile), stableJson),
        modes: orderBy(resolution.modes, (mode) => String(mode.id)),
        absoluteMaximumRatings: orderBy(resolution.absoluteMaximumRatings ?? [], (rating) => `${rating.pinName} ${rating.characteristicType}`),
        operatingCharacteristics: orderBy(resolution.operatingCharacteristics ?? [], (characteristic) => `${characteristic.pinName} ${characteristic.characteristicType}`),
        boundaries: orderBy(resolution.boundaries.map(stripVolatile), stableJson),
        resources: orderBy(resolution.resources, (resource) => resource.name),
        functions: orderBy(resolution.functions.map(stripVolatile), (fn) => String(fn['name'] ?? '')),
        signalDifferentialPairs: orderBy(resolution.signalDifferentialPairs.map((pair) => ({
            pairName: pair.pairName,
            positive: signalName(pair.positiveId),
            negative: signalName(pair.negativeId),
            differentialVoltageSwing: pair.differentialVoltageSwing,
        })), (pair) => pair.pairName),
    };
    return canonicalizeKeys(view);
}
//# sourceMappingURL=package-resolution-diff-view.js.map